import React from 'react';
import moment from 'moment';
import { sortBy } from 'lodash';
import { Tooltip, OverlayTrigger } from 'react-bootstrap';
// import uniq from 'lodash/uniq';
// import flatten from 'lodash/flatten';
import * as utils from '../../utils/utils';
import { convertTimeToNewFormat } from '../common/utils'

const renderOverlay = location => {
  if (!location.startDate || !location.endDate) return <span></span>;
  const startDate = moment(location.startDate).format('MMM D');
  const endDate = moment(location.endDate).format('MMM D');
  return (
    <Tooltip id="tooltip">
      <span>{startDate != endDate ? `${startDate} to ${endDate}` : startDate}</span>
      {location.location && <span>, {location.location} </span>}
    </Tooltip>
  );
};


// const getMinMaxDate = (locations) => {
//   const dates = locations.map((l) => ([l.startDate, l.endDate]));
//   const filteredDates = uniq(flatten(dates));
//   filteredDates.sort((a, b) => new Date(a) - new Date(b)); // sort metting dates asc.

//   return {
//     min: filteredDates[0],
//     max: filteredDates[filteredDates.length - 1]
//   }
// }

const LocationRow = ({ locations }) => {
  let newLocation = locations.map(location => ({ ...location, weekDay: moment(location.startDate).weekday() }));
  newLocation = sortBy(newLocation, ['weekDay']);
  // const { min, max } = getMinMaxDate(newLocation);

  return (
    <ul>
      {newLocation.map((l, i) => {
        return (
          <OverlayTrigger key={i} placement="right" overlay={renderOverlay(l)}>
            <li className="location-row">
              {/* <span className="text-bold">{l.location} </span> */}
              <span>
                {l.days.map((m, j) => {
                  return <span key={j}>{utils.convertDayShort(m)}&nbsp;</span>;
                })}
                {convertTimeToNewFormat(l.startTime)}-{convertTimeToNewFormat(l.endTime)}
              </span>
            </li>
          </OverlayTrigger>
        );
      })}
      {/* { min && max && (
        <li className="location-row">
          [{moment(min).format('MMM D')}-{moment(max).format('MMM D')}]
        </li>
      )} */}
    </ul>
  );
};

export const LocationColumn = ({ locations }) => {
  let newLocation = locations.map(location => ({ ...location, weekDay: moment(location.startDate).weekday() }));
  newLocation = sortBy(newLocation, ['weekDay']);
  return (
    <div>
      {newLocation.map((l, i) => {

        return (
          <OverlayTrigger key={i} placement="right" overlay={renderOverlay(l)}>
            <li className="location-row">
              {/* <span className="text-bold">{l.location} </span> */}
              <span>
                {l.days.map((m, j) => {
                  return <span key={j}>{utils.convertDayShort(m)}&nbsp;</span>;
                })}
                {convertTimeToNewFormat(l.startTime)}-{convertTimeToNewFormat(l.endTime)}
              </span>
            </li>
          </OverlayTrigger>
        );
      })}
    </div>
  );
}

export default LocationRow;



// WEBPACK FOOTER //
// ./src/components/rank/LocationRow.js